import { forwardRef, HTMLProps } from 'react'
import { FieldError } from 'react-hook-form'

import { cn } from '../libs/tailwindMerge'

interface InputProps extends HTMLProps<HTMLInputElement> {
  label?: string
  error?: FieldError | undefined
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { id, label, error, className, required, ...rest },
  ref,
) {
  return (
    <>
      {label &&
        <label htmlFor={id} className="block text-sm/6 font-medium text-gray-900 mb-1">
          {label}
          <span className={cn(
            'text-red-500 ml-2',
            !required && 'hidden',
          )}
          >
            *
          </span>
        </label>}
      <div>
        <input
          ref={ref}
          className={cn(
            'block w-full rounded-[4px] read-only:bg-slate-100 bg-white px-3 py-[0.445rem] text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6',
            className,
          )}
          {...rest}
        />
        {
          error?.message !== '' && (
            <span className="text-xs font-medium text-red-500">
              {error?.message}
            </span>
          )
        }
      </div>
    </>
  )
})
